module.exports = __webpack_public_path__ + "img/10861_L.c097aa11.png";